import React from 'react';
import { Expandable, Text, Title, TitleProps } from '@gjensidige/builders-components';
import './CoverageList.scss';
import './CommonCoverageList.scss';
import {
  Coverage,
  CoverageItemDetials,
  FullCoverageCollection
} from '../../interfaces/Types';
import { InsuranceHelper } from '../../utils/InsuranceHelper';
import tracker from '../../tracking';

interface CommonCoverageListProps {
  fullCoverageList: FullCoverageCollection[];
  expandSections: any;
  selectedCoverage: string;
  setIsExpanded: any;
  isExpanded: boolean;
  productName: string;
  commonCoverageClass: string;
}
const getContent = (coverageItem: Coverage) => {
  const contentList = coverageItem.commonDescription
    ? coverageItem.commonDescription
    : coverageItem.description;
  function createMarkup(text: string) {
    return { __html: text };
  }
  const content =
    !InsuranceHelper.isEmptyObject(contentList) &&
    contentList.map((descriptionList: CoverageItemDetials, index: number) => {
      return (
        <div key={index} className="common-coverage-desc-wrapper pt-1">
        
          <Title as={"h6" as TitleProps['as']}>{descriptionList.title}</Title>
          {descriptionList.details
            .split('\n')
            .map((text: string, index: number) => {
              return (
                <div
                  className={text.trim().length > 0 ? '' : 'pt-1'}
                  key={index}
                  dangerouslySetInnerHTML={createMarkup(text)}
                ></div>
              );
            })}
          {descriptionList.detailsList && (
            <ul>
              {descriptionList.detailsList.map((item, index) => (
                <li key={index}>
                  <Text size="body">{item}</Text>
                </li>
              ))}
            </ul>
          )}
        </div>
      );
    });
  return <div className="coverage-info px-1 pb-1">{content}</div>;
};

export const CommonCoverageList = (props: CommonCoverageListProps) => {
  const toggleSection = (isOpen: boolean, label: string) => {
    /***
      Custom tracking as the builders component version used in the app does not track scenario label and steps.
      Fix for https://gjensidige.atlassian.net/browse/SE-6433
      TODO: Remove the custom tracking once we migrated to new builders-components, if it supports the desired tracking.
    ***/
    tracker.trackEvent(
      {
        eventAction: isOpen ? 'expand' : 'minimize',
        eventCategory: 'expandable',
        eventKey: 'interact',
        eventLabel: label
      }
    )
    props.setIsExpanded(isOpen)
    props.expandSections(label)
  
  }
  return (
    <div
      className={`common-coverage-list-section ${props.commonCoverageClass}`}
    >
      {props.fullCoverageList[0].coverageLists?.map(
        (coverage: Coverage, index) => {
          return (
            // <div
            //   className="common-coverage-item-wrapper"
            //   //onClick={() => props.expandSections(coverage.name)}
            //   key={index}
            // >
            <React.Fragment 
              key={index}
            >
              <Expandable
                variant="line-white-yellow"
                open={
                  coverage.name === props.selectedCoverage && props.isExpanded
                }
                onChange={(isOpen) => toggleSection(isOpen, coverage.name)}
                tracking={false}
                className="common-coverage-expandable-wrapper border-left"
              >
              <Expandable.Title className="included-coverage-item">{coverage.name}</Expandable.Title>
                <Expandable.Content>
                  {getContent(coverage)}
                </Expandable.Content>
              </Expandable>
             {/* </div> */}
            </React.Fragment>
          );
        }
      )}
    </div>
  );
};
